import React from "react";

import { Container } from "mondrian-react";
import Footer from "components/Footer";
import SimpleHeader from "../Header/SimpleHeader";

export default function PublicPage(props) {
  return (
    <>
      <div className="cred-main">
        <SimpleHeader />
        <div className="cred-main-content" id="mdn-MainContent">
          <Container>
            <div className="mdn-Row">
              <div className="mdn-Col-md-6">
                <div className="formBox">
                  <div className="innerBox">{props.children}</div>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </>
  );
}
